class PhotoViewerService {
    constructor() {
        this.showPhotos = null;
    }

    openPhotoViewer(data) {
        // build items array
        const photos = data.currentNode.children.map(p => {
            if (p.type === 'file') {
                return {
                    src: p.src,
                    w: p.width,
                    h: p.height
                };
            }
        });

        // Find the index of the selected photo
        const index = photos.indexOf(photos.filter(p => p.src === data.selectedPhoto.src)[0]);

        this.showPhotos({ photos, index });
    }

    // Reference Functions
    setShowPhotosRef(refFunc) { this.showPhotos = refFunc; }
}

export default new PhotoViewerService();
